import { useEffect, useState } from "react";
import { AdminNav } from "../layouts/AdminNav";
import { Outlet } from "react-router-dom";
import "../assets/css/dashboard.css";
import useWindowDimensions from "../hooks/useWindowSize";
import { defaultUrl } from "../features/actions";
import { makePostRequest } from "../utilities/common";
import toast from "react-hot-toast";

export const Dashboard = () => {
  const { width } = useWindowDimensions();
  const isMobileScreen = width < 440;

  const [isImpersonating, setIsImpersonating] = useState<boolean>(false);
  const [impersonatedUser, setImpersonatedUser] = useState<any>(null);

  useEffect(() => {
    const tempToken = localStorage.getItem("temp_impersonate_token");
    const tempUserStr = localStorage.getItem("temp_impersonate_user");

    if (tempToken) {
      sessionStorage.setItem("token", tempToken);
      if (tempUserStr) {
        sessionStorage.setItem("user", tempUserStr);
        setImpersonatedUser(JSON.parse(tempUserStr));
      }
      sessionStorage.setItem("isImpersonated", "true");
      localStorage.removeItem("temp_impersonate_token");
      localStorage.removeItem("temp_impersonate_user");
      localStorage.removeItem("temp_is_impersonated");
      setIsImpersonating(true);
    } else if (sessionStorage.getItem("isImpersonated") === "true") {
      setIsImpersonating(true);
      const userStr = sessionStorage.getItem("user");
      if (userStr) {
        try {
          setImpersonatedUser(JSON.parse(userStr));
        } catch (e) {
          // ignore parsing error
        }
      }
    }
  }, []);

  const handleStopImpersonation = async () => {
    toast.loading("Stopping impersonation session...");
    try {
      await makePostRequest(`${defaultUrl}/impersonation/stop`, {});
      sessionStorage.removeItem("isImpersonated");
      toast.remove();
      toast.success("Impersonation session ended");
      setTimeout(() => {
        window.close();
        window.location.href = "/";
      }, 500);
    } catch (err: any) {
      toast.remove();
      sessionStorage.removeItem("isImpersonated");
      toast.success("Impersonation session ended");
      setTimeout(() => {
        window.close();
        window.location.href = "/";
      }, 500);
    }
  };

  return (
    <div className="flex flex-col min-h-screen max-w-[100vw] overflow-hidden">
      {isImpersonating && (
        <div className="bg-amber-500 text-white font-bold px-5 py-2.5 flex items-center justify-between shadow-md text-xs z-50 shrink-0">
          <div className="flex items-center gap-2">
            <span className="bg-amber-600 text-white text-[10px] font-black px-2 py-0.5 rounded uppercase tracking-wider">
              Staff Impersonation Mode
            </span>
            <span>
              You are currently reviewing dashboard as:{" "}
              <strong className="underline">
                {impersonatedUser?.firstname} {impersonatedUser?.surname}
              </strong>
            </span>
          </div>
          <button
            type="button"
            onClick={handleStopImpersonation}
            className="bg-white text-amber-700 hover:bg-amber-50 px-3 py-1 rounded-lg font-extrabold shadow-sm active:scale-95 transition-all text-xs cursor-pointer"
          >
            Stop Impersonation
          </button>
        </div>
      )}
      <div className="flex flex-1 max-w-[100vw] border-box overflow-hidden">
        <div>
          <AdminNav />
        </div>
        <div
          className={`!w-full ${
            isMobileScreen
              ? "pl-[26px] overflow-auto max-w-[98%]"
              : "overflow-auto max-w-[100%]"
          }`}
        >
          <div className="dASI">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
